import React, { useState } from 'react';
// import  './Cart.css';
// import styles from './cart.modules.css';
import './cart.css'
// import image from '../../assets/shirtFront.jpg';
import Navbar from '../NavbarFooter/Navbar'
import Footer from '../NavbarFooter/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCart } from '../Redux/CartSlice';
import axios from 'axios';

function Cart() {

    const dispatch = useDispatch();
    const [colorChange, setColorchange] = useState("");
    const changeNavbarColor = () => {
        if (window.scrollY >= 10) {
            setColorchange(" rgb(70, 70, 70)");
        }
        else {
            setColorchange("");
        }
    };
    window.addEventListener('scroll', changeNavbarColor);




    const carts = useSelector((state) => state.carts.items);
    // const noOfItems = carts.length;
    const priceTotalInt = useSelector((state) => state.carts.totalPrice);
    const priceTotal = priceTotalInt.toLocaleString();

    const userID = useSelector((state) => state.user.userID);

    const handleDelete = async (id, productID, name, number, size) => {
        dispatch(deleteCart({ id, }));

        //////////////////
        // console.log(`\nuserId=${userID}\nproductId=${id}\nname=${name}\nnumber=${number}\nsize=${size}`);



        try {

            const toDeleteItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/deleteItem", { 
                    userId: userID,
                    productId: productID,
                    name: name,
                    number: number,
                    size: size, 
            });

            // console.log(`\n\nThe product is saved in database\n${toDeleteItem}`)

        }
        catch (error) {
            console.error("Error in saving cart item in db, Login.js", error);
        }

    }



    return (

        <div className='mpBG'>

            <Navbar bgcolor={colorChange} />

            {carts && carts.length>0 ? (
            <div className='adjustCart'>


                
                <div className='Inner1C'>

                    <div className='headingC'>
                        {/* <div>Did you get a gift card from a friend? Enter it here!</div> */}
                        <div className='cartsC'>Cart</div>
                        {/* <div>*Customs duties may be applied for non-EU countries</div> */}
                        <span className='dividerC'></span>
                    </div>

                    <div className='borderC'>
                        <h3 style={{ width: '25%', textAlign: 'center' }}>Subtotal</h3>
                        <h3 style={{ width: '20%', textAlign: 'center' }}>Quantity</h3>
                        <h3 style={{ width: '55%', textAlign: 'center' }}>Product</h3>
                    </div>
                    <span className='divider2C'></span>

                        
                    {carts.slice().reverse().map((cart, index) => (
                        <div key={index} className='dataC'>
                            <div className='proNamePhoto'>

                                <div className='picC'>
                                    {cart.image && (
                                        <img src={cart.image} alt='Product' />
                                    )}
                                    <div style={{ paddingTop: '4%' }}>
                                        <h3 style={{ padding: '0%', margin: '0%', marginBottom: '2%' }}>{cart.proName}</h3>
                                        <div className='circleSeparate'></div>
                                        {cart.name && <h5>Name = {cart.name}</h5>}
                                        {cart.number && <h5>Number = {cart.number}</h5>}
                                        <h5>Size = {cart.size}</h5>
                                        <h4>Price = {cart.price}</h4>
                                    </div>
                                </div>
                                <div className='quantityDivC'>
                                    <h3>{cart.quantity}</h3>
                                    {/*<input className='input' type ="text"/>*/}</div>
                                <div className='totalC'>{cart.subtotal.toLocaleString()}</div>
                            </div>
                            <div className='proDetailC'>

                                {/* <h3 style={{ color: 'white', margin: '25px 10px', fontWeight: 'bold' }}> Lorem ipsum dolor sit amet consectetur adipisicing elit.<br /> </h3>
                            <h3 style={{ marginTop: '10px' }}>Rs. 2,914</h3>
                            <table className='userNameNum'>
                                <th>Name</th>
                                <th>Number</th>
                                <tr>
                                    <td>Faisal</td>
                                    <td>10</td>
                                </tr>
                            </table> */}
                                <h3 style={{ opacity: "0.5", marginTop: '10px', color: 'red', cursor: 'pointer', fontSize: '1rem' }} onClick={() => handleDelete(cart.id, cart.productID, cart.name, cart.number, cart.size)}><i>Remove</i></h3>

                            </div>
                            <span className='divider2C'></span>
                        </div>
                    ))}
                    <br /><br />

                </div>


                <div className='Inner2C'>
                    <h1 className='in2hC'>Cart Total</h1> 
                    <span className='divider2C'></span>
                    <div className='shippingC'>
                        <div style={{ width: '40%', margin: 'auto' }}><h4 style={{ color: "white" }}>Shipping</h4></div>

                        <div className='shipC'>
                            <span>Standard shipping: <b>PKR 300</b></span>
                            <span>Shipping in Pakistan only</span> 
                        </div>
                    </div>


                    <span className='divider2C'></span>

                    <div className='grandC'>
                        <div style={{ width: '40%' }}><h3 style={{ color: "white" }}>Total</h3></div>

                        <div style={{ textAlign: 'center', flexGrow: '1' }}><h3>{priceTotal}</h3></div>
                    </div>
                    <span className='divider2C'></span>

                    <div className='btnC'>

                        <button className='buttonC'> PROCEED WITH ORDER</button>

                    </div>

                </div>

            </div>
            ) : ( 
                
            <div className='adjustCart'>


                
            <div className='Inner1Cc'>
                <h1 className='noItemsCart'>No items in the cart!</h1>
 
            </div>

 
        </div>

            )}
            <Footer />
        </div>

    )
}

export default Cart

